export const identity = {
  identityFormTitle: "Completa tus datos",
  identityFormDescription: "Ingresa tu documento de identidad para continuar.",
  identityFormSubmit: "Continuar",
  identityFormSave: "Guardar y continuar",
  identityFormVerifying: "Consultando...",
  identityFormSaving: "Guardando...",
  identityFormErrorTitle: "No se pudo completar",
  identityCedulaLabel: "Tipo y número de identificación",
  identityIdTypeLabel: "Tipo de identificación",
  identityCedulaRequired: "Ingresa tu número de documento",
  identityCedulaLength: "Debe contener entre 6 y 10 dígitos",
  identityRutPlaceholder: "12345678-9",
  identityRutRequired: "Ingresa tu RUT chileno",
  identityRutInvalid: "Ingresa un RUT chileno válido (formato: 12345678-9)",
  identityFirstNameLabel: "Nombre",
  identityFirstNamePlaceholder: "Tu nombre",
  identityFirstNameRequired: "Ingresa tu nombre",
  identityLastNameLabel: "Apellido",
  identityLastNamePlaceholder: "Tu apellido",
  identityLastNameRequired: "Ingresa tu apellido",
  identityBirthdateLabel: "Fecha de nacimiento",
  identityBirthdatePlaceholder: "Selecciona tu fecha de nacimiento",
  identityBirthdateRequired: "Ingresa tu fecha de nacimiento",
  identityManualFallbackHint:
    "No pudimos verificar tu cédula automáticamente. Completa tus datos manualmente para continuar.",
  identityChangeCedula: "Cambiar cédula",
  identityVerifiedLabel: "Cédula verificada",

  identityError_generic: "No se pudo completar tu registro. Intenta de nuevo.",
  identityError_invalid_document: "El formato del documento no es válido.",
  identityError_underage: "Debes ser mayor de 18 años para registrarte.",
  identityError_document_not_found: "No encontramos tu cédula en el registro civil.",
  identityError_document_already_registered: "Esta cédula ya está registrada. Inicia sesión con tu cuenta existente.",
  identityError_verification_expired: "La verificación expiró. Vuelve a ingresar tu cédula.",
  identityError_verification_invalid: "La verificación no es válida. Vuelve a ingresar tu cédula.",
  identityError_verification_required: "Debes verificar tu cédula antes de continuar con Google.",
  identityError_kyc_unavailable: "El servicio de verificación no está disponible. Intenta más tarde.",
  identityError_rate_limit_exceeded: "Has realizado demasiados intentos. Espera unos minutos e inténtalo de nuevo.",

  onboardingModalTitle: "Completa tu perfil",
  onboardingContinue: "Continuar",
  onboardingBack: "Atrás",
  onboardingLater: "Lo haré más tarde",
  onboardingConfirm: "Confirmar y guardar",
  onboardingPagoMovilTitle: "Pago Móvil",
  onboardingPagoMovilDescription: "Agrega tu banco y teléfono para depósitos y retiros en bolívares.",
  onboardingPhoneDigits: "Ingresa los 7 dígitos restantes del teléfono",
  onboardingSuccessTitle: "Perfil completado",
  onboardingSuccessMessage: "Tu identidad y cuenta de Pago Móvil quedaron registradas.",
  onboardingSuccessProfileOnly: "Tus datos quedaron registrados correctamente.",
  onboardingErrorTitle: "No se pudo completar el registro",
  onboardingErrorMessage: "Verifica tus datos e inténtalo de nuevo.",
  onboardingReferralWarningTitle: "Código de referido no aplicado",
};
